import {lazy} from 'react';

const loadProposalRequestPage = () => import('./ProposalRequestPage');
export const ProposalRequestPageLoad = lazy(loadProposalRequestPage);

const loadOldProposalRequestPage = () => import('./OldProposalRequestPage');
export const OldProposalRequestPageLoad = lazy(loadOldProposalRequestPage);

const loadAllProposalRequestPage = () => import('./AllProposalRequestPage');
export const AllProposalRequestPageLoad = lazy(loadAllProposalRequestPage);

const loadMyProposalRequestPage = () => import('./MyProposalRequestPage');
export const MyProposalRequestPageLoad = lazy(loadMyProposalRequestPage);

const loadProposalRequestDetailsPage = () => import('./ProposalRequestDetailsPage');
export const ProposalRequestDetailsPageLoad = lazy(loadProposalRequestDetailsPage);

const loadNotaryProposalPageLoad = () => import('./NotaryEditProposalPage');
export const NotaryProposalPageLoad = lazy(loadNotaryProposalPageLoad);


